import { api } from "../api";

export const invitationsApi = {
    getMagicLink: async (invitationCode: string) => {
        const { data } = await api.get(`/invitations/public/${invitationCode}/magic-link`);
        return data;
    },

    validateInvitationCode: async (invitationCode: string) => {
        const { data } = await api.get(`/invitations/public/${invitationCode}`);
        return data;
    },
};